import React from 'react';
import { Table } from 'react-bootstrap';
import moment from 'moment';

export const FutureHoldConflictBody = ({ conflicts, dateFormat, t }) => (
    <div className="hold-project-step-body">
        <div className="border-radius-10 d-flex align-items-center p-2 gap-3 fw-600 fs14 mb-3" style={{ backgroundColor: '#f8d7da', border: '1px solid #dc3545' }}>
            <i className="fa fa-exclamation-triangle" />
            {t("This hold starts before a hold already registered for some of the selected employees. Applying it now would push that hold's dates - including its vacation - further out.")}
        </div>

        <div className="table-scroll">
            <Table className="table-sm fs12 table-container">
                <thead>
                    <tr>
                        <th className="text-start">{t('Hold Period')}</th>
                        <th className="text-start">{t('Affected Employees')}</th>
                        <th className="text-start">{t('Reason')}</th>
                    </tr>
                </thead>
                <tbody>
                    {conflicts.map(c => (
                        <tr key={c.meta_data_id}>
                            <td className="text-start">
                                {moment(c.from_date).format(dateFormat)} &rarr; {moment(c.to_date).format(dateFormat)}
                            </td>
                            <td className="text-start">{(c.affected_member_names || []).join(', ')}</td>
                            <td className="text-start">{c.reason || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>

        <div className="mt-3 pt-2 border-top text-center fs13">
            {t('Reverting the hold(s) above will undo all the future template changes they made, restoring those employees to their original schedule.')}
            {' '}{t("Once reverted, this hold can be registered without shifting anyone's vacation.")}
        </div>
    </div>
);
